module.exports = __webpack_public_path__ + "img/sz.cfb8269f.svg";